/**
 * 开放平台相关接口
 */
import { get } from '@fe/common/lib/ajax';
// 有赞相关
const API_PREFIX = '/api/store/opf';

/**
 * 获取商铺id
 */
export function getKdtId() {
  return get(`${API_PREFIX}/youzan/getKdtId`);
}
/**
 * 获取有赞支付页面
 * @param {string} appId 作品id
 */
export function getYouzanBill(appId, kdtId) {
  return get(`${API_PREFIX}/youzan/getYouzanBill`, { appId, kdtId });
}

/**
 * 检查支付状态
 * @param {string} appId 作品id
 */
export function checkYouzanBill(appId, kdtId) {
  return get(`${API_PREFIX}/youzan/checkYouzanBill`, { appId, kdtId });
}
